
import React from 'react';
import BaseModalComponent from './BaseModal';
import Uploader from 'react-images-upload';
//to use history.push
import { withRouter, Link } from 'react-router-dom';

class Ticket extends BaseModalComponent {
  constructor(props) {
    super(props, "tickets", props.Id, props.ParentComponent);
    this.state.subModuleName = "tickets";
    this.state.replyContent = '';
    this.state.attachment = '';

    this.onDropAttachment = this.onDropAttachment.bind(this);
  }
  onDropAttachment(picture) {
    if (picture.length === 0) {
      return;
    }
    let reader = new FileReader();
    let file = picture[0];

    reader.onloadend = () => {
      this.state.attachment = reader.result;
    }
    reader.readAsDataURL(file)
  }
  componentDidUpdate() {
    super.componentDidUpdate();
  }
  setTicketMessage(e) {
    //پیام با ای دی صفر رو جهت ثبت پیام جدید ایجاد کردیم
    for (let i = 0; i < this.state.form_data.record.Details.length; i++)
      if (this.state.form_data.record.Details[i].id === 0)
        this.state.form_data.record.Details[i].content = e.target.value;

    this.state.replyContent = e.target.value;
  }
  changeStatus(status) {
    let type = "change_status";
    fetch(this.state.get_url, {
      method: 'POST',
      body: JSON.stringify({
        "action": type,
        "form": { status: status, id: this.state.form_data.record.id }
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then((resualt) => {
        if (resualt.status === 1) {
          this.showToast('پیام با موفقیت بسته شد.', 'success');
          this.go("/tickets/dashboard/")
        }
        else {
          if (resualt.message === undefined)
            this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.', 'danger');
          else
            this.showToast(resualt.message, 'warning');
        }
      });
  }

  saveForm2(to_staff_id = null, isNote = false) {
    if (this.state.replyContent === "") {
      this.showToast("لطفا متن پیام را وارد نمایید.", "warning");
      return;
    }

    this.lockScreen();

    var type = "edit";
    if (this.state.form_data.record.id <= 0) {
      type = "add";
    }
    fetch(this.state.get_url, {
      method: 'POST',
      body: JSON.stringify({
        "action": type,
        "form": {
          id: this.state.form_data.record.id,
          to_staff_id: to_staff_id,
          isNote: isNote,
          replyContent: this.state.replyContent,
          attachment: this.state.attachment
        }
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((resualt) => {
      this.unLockScreen();
      if (resualt.status === 1) {
        this.showToast('اطلاعات با موفقیت ذخیره شد.', 'success');

        //ادرس مسیر جاری رو بدست میاره و اسم دامین و پروتکل رو از ادرس حذف میکنه
        var u = window.location.href.toString().replace(window.location.origin + '/organ/', '/');

        if (u.substr(-1) != '/') u = u + "/";

        //چون ابتدا و انتها اسلش داریم داریم برای همین بایستی توجه بشه که اندیس اول و اخر ارایه خالی خواهد بو
        u = u.toLocaleLowerCase();
        let urlSections = u.split("/");
        // module/action/id

        this.go('/' + urlSections[1] + "/");

      }
      else {
        if (resualt.message === undefined)
          this.showToast('برنامه قادر به اجرای درخواست شما نمی باشد.', 'danger');
        else
          this.showToast(resualt.message, 'warning');
      }
    });
  }
  renderResponseForm(){
    return(
          <div className="form-horizontal">
            <div className="box-body">
              <div className="form-group">
                <label className="col-sm-1 control-label">متن پیام</label>
                <div className="col-sm-11">
                  <textarea style={{"height":"140px"}} defaultValue={this.state.replyContent} className="form-control" placeholder="متن پیام" onChange={(e) => { this.setTicketMessage(e) }}></textarea>
                </div>
              </div>
              <div className="form-group">
                <div className="col-sm-12">
                    <Uploader
                      withPreview={true}
                      className="paperMediaUploader"
                      withIcon={false}
                      withLabel={false}
                      buttonText='انتخاب فایل پیوست پیام'
                      fileSizeError="حجم فایل انتخابی زیاد است"
                      fileTypeError = "فرمت فایل انتخابی نامعتبر است"
                      onChange={this.onDropAttachment}
                      accept="*"
                      imgExtension={['.pdf', '.doc', '.docx', '.ppt', '.pptx','.png','.zip','.gif','.jpg','.jpeg']}
                      singleImage={true}
                      maxFileSize={5242880}
                    />
                </div>
              </div>
            </div>
          </div>
    );
  }
  renderNewForm() {
    return (
      <div className="form-horizontal">
        <div className="box-body">
          <div className="form-group">
            <label className="col-sm-1 control-label">متن پیام</label>
            <div className="col-sm-11">
              <textarea style={{ "height": "140px" }} className="form-control" placeholder="متن پیام" onChange={(e) => { this.setTicketMessage(e) }}></textarea>
            </div>
          </div>
          <div className="form-group">
            <div className="col-sm-12">
              <Uploader
                withPreview={true}
                className="paperMediaUploader"
                withIcon={false}
                withLabel={false}
                buttonText='انتخاب فایل پیوست پیام'
                fileSizeError="حجم فایل انتخابی زیاد است"
                fileTypeError="فرمت فایل انتخابی نامعتبر است"
                onChange={this.onDropAttachment}
                accept="*"
                imgExtension={['.pdf', '.doc', '.docx', '.ppt', '.pptx', '.png', '.zip', '.gif', '.jpg', '.jpeg']}
                singleImage={true}
                maxFileSize={5242880}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderBody() {
    return (<div className="row">
      <div className="col-md-12">

        {this.state.form_data.record.id > 0 ? [
          <div className="box box-primary direct-chat direct-chat-primary">
            <div className="box-header with-border"><h3 className="box-title">سوابق پیام ها</h3></div>
            <div className="box-body">
              <div className="direct-chat-messages" style={{ "height": "auto" }}>

                {this.state.form_data.record.Details.map(hit =>
                  hit.id === 0 ? null :
                    !this.isNull(hit.Person) ?
                      <div className="direct-chat-msg">
                        <div className="direct-chat-info clearfix">
                          <span className="direct-chat-name pull-left">
                            {hit.Person.fname + ' ' + hit.Person.lname}
                            {!this.isNull(hit.ToStaff) && <i className="text-green"> (ارجاع به {hit.ToStaff.name})</i>}
                          </span>
                          {!this.isBlank(hit.attachment) && <a className="text-blue" target="_blank" href={"/media/t/" + hit.attachment}> <i className="fa fa-paperclip"></i> مشاهده فایل پیوست </a>}
                          <span className="direct-chat-timestamp pull-left mr-l-5">{this.g2j(hit.date)}</span>
                        </div>
                        <img className="direct-chat-img" src={this.toImageUrl(hit.Person, 'real_person')} alt="" />
                        <div className="direct-chat-text" dangerouslySetInnerHTML={{ __html: hit.content }}>
                        </div>
                      </div>
                      :
                      !this.isNull(hit.Staff) ?
                        <div className="direct-chat-msg right">
                          <div className="direct-chat-info clearfix">
                            <span className="direct-chat-name pull-right">{hit.Staff !== null ? hit.Staff.name : ""}
                            {!this.isNull(hit.ToStaff) && <i className="text-green"> (ارجاع به {hit.ToStaff.name})</i>}
                            </span>
                            {!this.isBlank(hit.attachment) && <a className="text-blue" target="_blank" href={"/media/t/" + hit.attachment}> <i className="fa fa-paperclip"></i> مشاهده فایل پیوست </a>}                            <span className="direct-chat-timestamp pull-right mr-r-5">{this.g2j(hit.date)}</span>
                          </div>
                          <img className="direct-chat-img" src={this.toImageUrl(hit.Staff, 'staff')} alt="" />
                          <div className="direct-chat-text" dangerouslySetInnerHTML={{ __html: hit.content }}>
                          </div>
                        </div>
                        :
                        hit.Person === null && hit.Staff === null ?
                          <div className="direct-chat-msg">
                            <div className="direct-chat-info clearfix">
                              <span className="direct-chat-name pull-left">
                                {this.state.form_data.record.name}
                                {!this.isNull(hit.ToStaff) && <i className="text-green"> (ارجاع به {hit.ToStaff.name})</i>}
                              </span>
                              {!this.isBlank(hit.attachment) && <a className="text-blue" target="_blank" href={"/media/t/" + hit.attachment}> <i className="fa fa-paperclip"></i> مشاهده فایل پیوست </a>}
                              <span className="direct-chat-timestamp pull-left mr-l-5">{this.g2j(hit.date)}</span>
                            </div>
                            <img className="direct-chat-img" src="/assets/images/no-pic.gif" alt="" />
                            <div className="direct-chat-text" dangerouslySetInnerHTML={{ __html: hit.content }}>
                            </div>
                          </div>
                        : null
                )}

              </div>
            </div>
          </div>
        ] : 
        null
        }
        <div className="box box-info">
          <div className="box-header with-border"><h3 className="box-title">ارسال پیام جدید</h3></div>
          {this.state.form_data.record.id > 0 ?
            this.renderResponseForm()
            :
            this.renderNewForm()
          }
          <div className="form-horizontal text-center" style={{"padding":"40px"}}>
            <button type="button" className="btn btn-success" onClick={(e) => { this.saveForm2(); }} style={{ "marginLeft": "5px" }}>ارسال</button>
          </div>
        </div>
      </div>
    </div>
    );
  }
  renderNormalView() {
    return (
          [
            this.state.form_data.record.id > 0 ?
              [
                " | "
                ,
                "وضعیت: "
                ,
                this.enumString(this.state.form_data.record.ticket_status, "ticket_status")
                ,
                " | "
                ,
                this.state.form_data.record.ticket_status !== 4 ?
                  <button className="btn btn-danger mr-r-5" onClick={e => this.changeStatus(4)}>بستن پیام</button>
                  : null
                ,
                <b className="text-blue pull-left">#{this.state.form_data.record.id}</b>
              ]
              : null
            ,
            this.renderBody()
          ]
    );
  }
  render() {
    if (this.state.form_data === null || this.state.form_data === undefined)
      return this.showLoading();
    if (this.state.form_data.status === 500 || this.state.form_data.status === 0)
      return this.render500();
    if (this.state.form_data.status === 404)
      return this.render404();
    if (this.state.form_data.status === 2)
      return this.renderNoAccess();
    if (this.state.form_data.status === 4)
      return this.renderNoLogin();
    return this.renderNormalView();
  }
}
const TicketEXP = withRouter(Ticket);
export default TicketEXP;